<template>

  <!--:prop="'setList.' + index + '.accounted'"-->
  <!--:rules="{-->
  <!--required: true, message: '占比不能为空', trigger: 'blur'-->
  <!--}"-->

  <div>
  <el-dialog :title="title" :visible.sync="open" width="850px" append-to-body :close-on-click-modal="false">

    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px" label-position="left">

    <div class="open-background">
      <div class="open-header">基本信息</div>
      <!--<el-form size="small" ref="form" :model="form" label-width="450px" label-position="left" :rules="rules">-->
        <div v-for="(item, index) in form.setList" :key="index">
          <el-form-item :label="item.name+'（满分' + item.full_mark +'分）'"
          :prop="'setList.' + index + '.accounted'"
          :rules="{
              required: true, message: '占比不能为空', trigger: 'blur'
          }"
                        label-width="450px"
          >
            <div>
              在项目总成绩中占比：
              <el-input v-model="item.accounted" placeholder="请输入名称" :style="{width:'20%'}"/>
              %
            </div>
          </el-form-item>
        </div>
      <!--</el-form>-->

    </div>

    <div class="open-background mt20">
      <div class="open-header">分数等级</div>
      <el-row :gutter="15">


          <el-col :span="8">
            <el-form-item label="满分" prop="full_mark">
              <el-input v-model="form.full_mark" placeholder="请输入满分" :disabled="true" :style="{width: '100%'}">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="及格分数线" prop="pass_mark">
              <el-input v-model="form.pass_mark" placeholder="请输入及格分数线" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优秀分数线" prop="good_mark">
              <el-input v-model="form.good_mark" placeholder="请输入优秀分数线" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
          </el-col>

      </el-row>
    </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
      <el-button @click="cancel" size="small">关 闭</el-button>
    </div>

  </el-dialog>



  </div>
</template>

<script>

  import { getProjectRuleClass, projectRuleSubmit, rule_detail, rule_edit } from "@/api/tearcher";


  export default {
    name: 'assessment',

    data() {
      return {
        loading: false,
        title: "项目考核规则设置", // 弹出层标题
        open: false,  // 是否显示弹出层

        titleGroup: "", // 弹出层标题
        openGroup: false,  // 是否显示弹出层

        class_id : undefined,


        remake : false,

        form : {
          setList : [],
        },



        // 表单校验
        rules: {
          full_mark: [{ required: true, message: '请输入满分', trigger: 'blur' },
            { pattern: /^\d{1,}$/, message: '请输入数字', trigger: 'blur' }],
          pass_mark: [{ required: true, message: '请输入及格分数线', trigger: 'blur' },
            { pattern: /^\d{1,}$/, message: '请输入数字', trigger: 'blur' }],
          good_mark: [{ required: true, message: '请输入优秀分数线', trigger: 'blur' },
            { pattern: /^\d{1,}$/, message: '请输入数字', trigger: 'blur' }],
        }
      }
    },
    mounted() {

    },

    props: {
      row: {
        type: Object
      }
    },

    computed: {

    },
    methods: {

      handleCreate() {
        this.open = true;
        getProjectRuleClass(this.row.id).then(res => {
          this.form.setList = res.data;
        })
      },
      handleUpdate() {
        this.open = true;
        rule_detail(this.row.id).then(res => {
          // this.setList = res.data.set_list;

          let data = res.data;
          let itemFom = {
            'id': data.id,
            'focus_project_id': data.focus_project_id,
            'full_mark': data.full_mark,
            'pass_mark': data.pass_mark,
            'good_mark': data.good_mark,
            'setList': res.data.set_list
          }

          this.form = itemFom;
        })
      },


      /** 提交按钮 */
      submitForm: function() {
        this.$refs['form'].validate(valid => {
          if (valid) {

            let o = {...this.form};

            if (Number(o.good_mark) > Number(o.full_mark)) {
              this.msgError("优秀分数线需要小于等于满分！")
              return false;
            }

            if (Number(o.pass_mark) > Number(o.full_mark)) {
              this.msgError("及格分数线需要小于等于满分！")
              return false;
            }

            if (o.id != undefined) {

              let itemSetList = [...this.form.setList]

              for (let c of itemSetList) {
                delete c.name;
                if (c.model === 1) {
                  o.network_training = c.accounted;
                }
              }
              o.structure = itemSetList;

              rule_edit(o).then(response => {
                if (response.error_code === 201) {
                  //this.msgSuccess('修改成功')
                  this.$message({
                    message: response.msg,
                    type: "success",
                    duration: messageDuration,
                  });
                  this.$emit("getList")
                  this.open = false
                }
              }).catch(reason => {
                console.log(reason)
              })
            } else {

              let it = [];
              for (let c of this.form.setList) {
                it.push({'class_id' : c.class_id, 'accounted' : c.accounted, 'model' : c.model})
                if (c.model === 1) {
                  o.network_training = c.accounted;
                }
              }
              o.structure = it;
              o.focus_project_id = this.row.id

              projectRuleSubmit(o).then(response => {
                if (response.error_code === 201) {
                  //this.msgSuccess('添加成功')
                  this.$message({
                    message: response.msg,
                    type: "success",
                    duration: messageDuration,
                  });
                  this.$emit("getList")
                  this.open = false
                }
              }).catch(reason => {
                console.log(reason)
              })
            }



          }
        })
      },
      // 表单重置
      reset() {
        this.form = {
          setList : [],
        };
        this.resetForm("form");
      },

      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },


      handleCreateGroup() {

        this.getSetList()
        this.titleGroup = '小组设置'
        this.openGroup = true
      },

      getSetList() {

      },


      handleGroupSet(data) {
        this.groupId = data.id;
        this.groupTitle = data.title;
      },

      GroupCancel() {
        this.groupId =0;
        this.groupTitle = '';
      },

      round(number, precision) {
        return Math.round(+number + 'e' + precision) / Math.pow(10, precision)
        //same as:
        //return Number(Math.round(+number + 'e' + precision) + 'e-' + precision);
      }
    },


    watch: {

      'form.setList': {
        deep: true,
        handler(val) {
          console.log(val)

          let sum = 0;
          for (let i of val) {
            sum += Number(i.full_mark) * (Number(i.accounted) / 100)
          }

          this.form.full_mark = this.round(sum, 2) ;
        }
      },
    },

  }
</script>

<style lang="less" scoped>
  .open-header {
    font-size: 18px;
    margin-bottom: 10px;
    color: #303133;
  }

  .open-background {
    background-color: #f2f2f2;
    padding: 10px;
  }
</style>
